import React from 'react'
import parse from 'html-react-parser'
import Link from '../utils/link';
import {ArrowRight} from './icons';
import Fade from 'react-reveal/Fade';
import Arrow1 from '../assets/images/arrow-01.png'
import Arrow2 from '../assets/images/arrow-02.png'
import Arrow3 from '../assets/images/arrow-03.png'
import Arrow4 from '../assets/images/arrow-04.png'
import Arrow5 from '../assets/images/arrow-05.png'
import Arrow6 from '../assets/images/arrow-06.png'
import Arrow7 from '../assets/images/arrow-07.png'
import Arrow8 from '../assets/images/arrow-08.png'

const arrows = {
  arrow1: Arrow1,
  arrow2: Arrow2,
  arrow3: Arrow3,
  arrow4: Arrow4,
  arrow5: Arrow5,
  arrow6: Arrow6,
  arrow7: Arrow7,
  arrow8: Arrow8,
}

const Services = ({title, subtitle, services}) => {

  return (
    <section className='serives'>
      <Fade bottom distance='30px'>
        <div className='services__inner'>
          <div className='services__wrapper'>
            <div className='services__title' data-sal='fade' data-sal-duration='1000' data-sal-delay='0'
                 data-sal-easing='ease'>
              {title && <h2>{parse(title)}</h2>}
            </div>
            <div className='services__subtitle' data-sal='fade' data-sal-duration='1000' data-sal-delay='0'
                 data-sal-easing='ease'>
              {subtitle && <p>{parse(subtitle)}</p>}
            </div>
          </div>
          <div className='services__items'>
            {
              services?.length > 0 && services.map((el, i) => (
                <Link key={i} to={el.uri} className='services__item'>
                  <div className='bg'></div>
                  {el.title && <h3>{parse(el.title.split(' ').join(' <br>'))}</h3>}
                  {el.acf?.excerpt && <p>{el.acf?.excerpt}</p>}
                  <img loading='lazy' className={`arrow arrow-${i + 1}`} src={arrows[`arrow${i + 1}`]} alt=""/>
                  <ArrowRight/>
                </Link>
              ))
            }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Services